<div class="filter">
    <h3>Results: {{ assignments.length }}</h3>
    <div class="buttons">
        <button
            mat-flat-button
            color="primary"
            (click)="isOpen = !isOpen"
            aria-label="Toggle filters"
        >
            <mat-icon>{{ isOpen ? "visibility_off" : "visibility" }}</mat-icon>
            Filters
        </button>
    </div>
</div>
<div class="filter-panel" [class.open]="isOpen">
    <div class="filter-panel-inner">
        <div class="filter-card">
            <form class="filter-fields" [formGroup]="filters">
                <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="filter-field-item"
                >
                    <mat-label>Search Bill</mat-label>
                    <mat-icon matSuffix>search</mat-icon>
                    <input
                        matInput
                        [formControlName]="'billSearch'"
                        placeholder="Bill ID or Title"
                    />
                </mat-form-field>
                <ng-container *ngFor="let field of fields">
                    <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        *ngIf="field.isSelectList"
                        class="filter-field-item"
                    >
                        <mat-label>{{ field.label }}</mat-label>
                        <mat-select [formControlName]="field.controlName">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option
                                *ngFor="
                                    let option of options.get(field.controlName)
                                "
                                [value]="option.name"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </form>
            <div class="filter-actions">
                <button
                    mat-flat-button
                    color="accent"
                    (click)="resetFilters()"
                    aria-label="Reset filters"
                >
                    Reset
                </button>
            </div>
        </div>
    </div>
</div>
